import { useEffect, useState, useMemo } from 'react';
import customEventBus from '@common/scripts/libs/eventBus';
const useNavigationTool = () => {
    const [intent, setIntent] = useState('mouse');
    const keyboardIntent = useMemo(() => {
        return intent === 'keyboard';
    }, [intent]);
    const mouseIntent = useMemo(() => {
        return intent === 'mouse';
    }, [intent]);
    const eventHanlder = (data) => {
        let tempIntent = (data === null || data === void 0 ? void 0 : data.isKeyboardMode) ? 'keyboard' : 'mouse';
        if (tempIntent !== intent) {
            setIntent(tempIntent);
        }
    };
    useEffect(() => {
        customEventBus.on('keyboard:mode', eventHanlder);
        return () => {
            customEventBus.off('keyboard:mode', eventHanlder);
        };
    }, [intent]);
    return {
        intent,
        keyboardIntent,
        mouseIntent,
    };
};
export default useNavigationTool;
